module.exports = __webpack_public_path__ + "img/photo2_8.ba8794a8.jpg";